"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorScrolling = void 0;
const react_router_dom_1 = require("react-router-dom");
const scrollToAnchor_1 = require("../../../../lib/helpers/scrollToAnchor");
const AnchorScrolling = () => {
    const history = (0, react_router_dom_1.useHistory)();
    history.listen(() => {
        (0, scrollToAnchor_1.scrollToAnchor)();
    });
    return null;
};
exports.AnchorScrolling = AnchorScrolling;
//# sourceMappingURL=index.js.map